import { useOverlayScrollLock } from 'components/scrollLockingOverlay/useOverlayScrollLock';
import Overlay, { IOverlayProps } from 'lqa-ui/lib/Components/Overlay';
import { FC } from 'react';
import * as React from 'react';

export const ScrollLockingOverlay: FC<IOverlayProps> = (props) => {
    useOverlayScrollLock(props.isOpen);
    return (<Overlay {...props}>{props.children}</Overlay>);
};
